import { CatalogLocale } from '../locale';

type LocalizedDictionaries<English extends Record<string, string>> = {
  readonly [Locale in Exclude<CatalogLocale, 'en'>]: Record<keyof English, string>;
} & {
  readonly en: English;
};

export const defineDomainTranslations = <const English extends Record<string, string>>(
  translations: LocalizedDictionaries<English>,
) => translations;
